<div class="sl-popover-backdrop"
     *ngIf="openConditionId || showSavedViews"
     (click)="closePopovers()"></div>

<!-- Reusable condition editor: field → range type → range values -->
<ng-template #conditionEditor let-condition>
  <div class="sl-popover-line">
    <select class="sl-popover-field"
            [ngModel]="condition.field"
            (ngModelChange)="setConditionField(condition, $event)"
            [attr.data-testid]="'sl-condition-field-' + condition.id">
      <option [ngValue]="null">Select a field…</option>
      <option *ngFor="let field of fields" [ngValue]="field.id">{{field.label}}</option>
    </select>
  </div>

  <div class="sl-popover-line" *ngIf="fieldOf(condition) && opsFor(condition).length > 1">
    <select class="sl-popover-op-select"
            [ngModel]="condition.op"
            (ngModelChange)="setConditionOp(condition, $event)"
            [attr.data-testid]="'sl-condition-op-' + condition.id">
      <option [ngValue]="null">Select a range type…</option>
      <option *ngFor="let op of opsFor(condition)" [ngValue]="op.id">{{op.label}}</option>
    </select>
  </div>

  <ng-container *ngIf="fieldOf(condition) && condition.op">
    <ng-container [ngSwitch]="fieldOf(condition).type">

      <div class="sl-popover-line" *ngSwitchCase="'metric'">
        <ng-container *ngIf="conditionArgCount(condition) > 0">
          <input type="number"
                 [ngModel]="condition.value"
                 (ngModelChange)="setConditionValue(condition, $event)"
                 [attr.data-testid]="'sl-condition-value-' + condition.id"
                 placeholder="—" />
          <span class="sl-popover-unit">{{conditionUnit(condition)}}</span>
          <ng-container *ngIf="conditionArgCount(condition) === 2">
            <span class="sl-popover-and">and</span>
            <input type="number"
                   [ngModel]="condition.value2"
                   (ngModelChange)="setConditionValue2(condition, $event)"
                   [attr.data-testid]="'sl-condition-value2-' + condition.id"
                   placeholder="—" />
            <span class="sl-popover-unit">{{conditionUnit(condition)}}</span>
          </ng-container>
        </ng-container>
      </div>

      <div class="sl-popover-line sl-popover-line-stack" *ngSwitchCase="'items'">
        <select multiple size="5"
                [ngModel]="condition.value || []"
                (ngModelChange)="setConditionList(condition, $event)"
                [attr.data-testid]="'sl-condition-items-' + condition.id">
          <option *ngFor="let item of itemOptions" [ngValue]="item.id">{{item.label}}</option>
        </select>
      </div>

      <div class="sl-popover-line" *ngSwitchCase="'flag'">
        <select [ngModel]="conditionFlagValue(condition)"
                (ngModelChange)="setConditionFlag(condition, $event)"
                [attr.data-testid]="'sl-condition-flag-' + condition.id">
          <option value="">Select…</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>

      <div class="sl-popover-line" [class.sl-popover-line-stack]="condition.op === 'isAnyOf'" *ngSwitchCase="'enum'">
        <ng-container *ngIf="conditionArgCount(condition) > 0">
          <select *ngIf="condition.op === 'isAnyOf'" multiple size="5"
                  [ngModel]="condition.value || []"
                  (ngModelChange)="setConditionList(condition, $event)"
                  [attr.data-testid]="'sl-condition-enum-' + condition.id">
            <option *ngFor="let option of enumOptions(condition)" [ngValue]="option.value">{{option.label}}</option>
          </select>
          <select *ngIf="condition.op !== 'isAnyOf'" class="sl-popover-field"
                  [ngModel]="condition.value"
                  (ngModelChange)="setConditionValue(condition, $event)"
                  [attr.data-testid]="'sl-condition-enum-' + condition.id">
            <option [ngValue]="null">Select…</option>
            <option *ngFor="let option of enumOptions(condition)" [ngValue]="option.value">{{option.label}}</option>
          </select>
        </ng-container>
      </div>

      <div class="sl-popover-line" *ngSwitchCase="'text'">
        <input type="text" class="sl-popover-text" *ngIf="conditionArgCount(condition) > 0"
               [ngModel]="condition.value"
               (ngModelChange)="setConditionValue(condition, $event)"
               [attr.data-testid]="'sl-condition-text-' + condition.id"
               placeholder="Type to match…" />
      </div>

      <div class="sl-popover-line" [class.sl-popover-line-stack]="conditionArgCount(condition) === 2" *ngSwitchCase="'date'">
        <ng-container *ngIf="conditionArgCount(condition) > 0">
          <input [type]="dateInputType(condition)" class="sl-popover-date"
                 [ngModel]="condition.value"
                 (ngModelChange)="setConditionValue(condition, $event)"
                 [attr.data-testid]="'sl-condition-date-' + condition.id" />
          <ng-container *ngIf="conditionArgCount(condition) === 2">
            <span class="sl-popover-and">and</span>
            <input [type]="dateInputType(condition)" class="sl-popover-date"
                   [ngModel]="condition.value2"
                   (ngModelChange)="setConditionValue2(condition, $event)"
                   [attr.data-testid]="'sl-condition-date2-' + condition.id" />
          </ng-container>
        </ng-container>
      </div>

    </ng-container>
  </ng-container>

  <p class="sl-popover-hint" *ngIf="fieldOf(condition)?.hint">{{fieldOf(condition).hint}}</p>
  <button type="button" class="sl-popover-delete" (click)="removeCondition(condition)">Delete filter</button>
</ng-template>

<!-- Chip row -->
<div class="sl-filter-row" [attr.data-testid]="testIdPrefix + '-content-filters'">
  <span class="sl-filter-row-label" *ngIf="rowLabel">{{rowLabel}}</span>

  <div class="sl-filter-chip-wrap" *ngFor="let condition of conditions">
    <span class="sl-filter-chip" [class.is-set]="isConditionActive(condition)">
      <button type="button"
              class="sl-chip-main"
              [attr.data-testid]="'sl-condition-chip-' + condition.id"
              (click)="toggleConditionEditor(condition.id)">
        <span class="sl-chip-label">{{conditionChipLabel(condition)}}</span>
        <span class="sl-chip-value">{{conditionChipValue(condition)}}</span>
      </button>
      <button type="button"
              class="sl-chip-remove"
              aria-label="Remove filter"
              (click)="removeCondition(condition)">&times;</button>
    </span>

    <div class="sl-filter-popover" *ngIf="openConditionId === condition.id">
      <div class="sl-popover-title">Filter</div>
      <ng-container *ngTemplateOutlet="conditionEditor; context:{$implicit: condition}"></ng-container>
    </div>
  </div>

  <button type="button"
          class="sl-filter-add"
          [attr.data-testid]="testIdPrefix + '-add-filter'"
          (click)="addCondition()">{{addLabel}}</button>

  <button type="button"
          class="sl-filter-advanced"
          [class.is-open]="isAdvancedFilter"
          [attr.data-testid]="testIdPrefix + '-advanced-toggle'"
          (click)="isAdvancedFilter = !isAdvancedFilter">
    Advanced filter <span class="sl-chevron">{{isAdvancedFilter ? '▾' : '▸'}}</span>
  </button>

  <div class="sl-filter-chip-wrap" *ngIf="presetStore">
    <button type="button"
            class="sl-filter-advanced"
            [class.is-open]="showSavedViews"
            [attr.data-testid]="testIdPrefix + '-saved-views-toggle'"
            (click)="toggleSavedViews()">
      Saved filters<span class="sl-saved-count" *ngIf="savedViews.length"> ({{savedViews.length}})</span>
      <span class="sl-chevron">▾</span>
    </button>

    <div class="sl-filter-popover sl-saved-popover" *ngIf="showSavedViews">
      <div class="sl-popover-title">Saved filters</div>

      <div class="sl-saved-view" *ngFor="let view of savedViews">
        <button type="button"
                class="sl-saved-apply"
                [attr.data-testid]="'sl-saved-view-' + view.id"
                (click)="applySavedView(view)">
          <span class="sl-saved-name">{{view.name}}</span>
          <span class="sl-saved-desc">{{describeSavedView(view)}}</span>
        </button>
        <button type="button"
                class="sl-saved-delete"
                aria-label="Delete saved filter"
                (click)="deleteSavedView(view)">&times;</button>
      </div>
      <div class="sl-popover-hint" *ngIf="!savedViews.length">Nothing saved yet.</div>

      <div class="sl-saved-new">
        <input type="text"
               [(ngModel)]="newViewName"
               placeholder="Name these filters…"
               [attr.data-testid]="testIdPrefix + '-save-view-name'" />
        <button type="button"
                class="button is-small is-info"
                [disabled]="!canSaveCurrentView"
                [attr.data-testid]="testIdPrefix + '-save-view'"
                (click)="saveCurrentView()">{{saveWouldReplace ? 'Update' : 'Save'}}</button>
      </div>
      <p class="sl-popover-hint">{{saveHint}}<ng-container *ngIf="saveWouldReplace"> A filter with this name exists — saving replaces it.</ng-container></p>
    </div>
  </div>

  <button type="button"
          class="sl-filter-clear"
          [attr.data-testid]="testIdPrefix + '-clear-filters'"
          [disabled]="!hasActiveFilters"
          (click)="clearAllFilters()">Clear</button>

  <ng-content select="[slot=trailing]"></ng-content>
</div>

<p class="sl-saved-notice" *ngIf="notice" [attr.data-testid]="testIdPrefix + '-saved-notice'">{{notice}}</p>

<!-- Advanced panel -->
<div class="sl-advanced-filter" *ngIf="isAdvancedFilter" [attr.data-testid]="testIdPrefix + '-advanced-panel'">
  <div class="sl-advanced-row" *ngFor="let condition of conditions; let i = index">
    <span class="sl-advanced-conj" [ngSwitch]="advancedConjunction(i)">
      <span *ngSwitchCase="'where'">Where</span>
      <select *ngSwitchCase="'select'" [ngModel]="joinMode" (ngModelChange)="setJoinMode($event)">
        <option value="AND">And</option>
        <option value="OR">Or</option>
      </select>
      <span *ngSwitchDefault>{{joinMode === 'OR' ? 'Or' : 'And'}}</span>
    </span>

    <select class="sl-advanced-select"
            [ngModel]="condition.field"
            (ngModelChange)="setConditionField(condition, $event)">
      <option [ngValue]="null">Select a field…</option>
      <option *ngFor="let field of fields" [ngValue]="field.id">{{field.label}}</option>
    </select>

    <select class="sl-advanced-select"
            *ngIf="fieldOf(condition) && opsFor(condition).length > 1"
            [ngModel]="condition.op"
            (ngModelChange)="setConditionOp(condition, $event)">
      <option [ngValue]="null">Select a range type…</option>
      <option *ngFor="let op of opsFor(condition)" [ngValue]="op.id">{{op.label}}</option>
    </select>

    <ng-container *ngIf="fieldOf(condition) && condition.op">
      <ng-container [ngSwitch]="fieldOf(condition).type">

        <ng-container *ngSwitchCase="'metric'">
          <ng-container *ngIf="conditionArgCount(condition) > 0">
            <input type="number" class="sl-advanced-number"
                   [ngModel]="condition.value"
                   (ngModelChange)="setConditionValue(condition, $event)"
                   placeholder="—" />
            <span class="sl-advanced-op">{{conditionUnit(condition)}}</span>
            <ng-container *ngIf="conditionArgCount(condition) === 2">
              <span class="sl-advanced-op">and</span>
              <input type="number" class="sl-advanced-number"
                     [ngModel]="condition.value2"
                     (ngModelChange)="setConditionValue2(condition, $event)"
                     placeholder="—" />
              <span class="sl-advanced-op">{{conditionUnit(condition)}}</span>
            </ng-container>
          </ng-container>
        </ng-container>

        <button type="button" class="sl-advanced-value" *ngSwitchCase="'items'"
                (click)="toggleConditionEditor(condition.id)">{{conditionChipValue(condition)}}</button>

        <select class="sl-advanced-select" *ngSwitchCase="'flag'"
                [ngModel]="conditionFlagValue(condition)"
                (ngModelChange)="setConditionFlag(condition, $event)">
          <option value="">Select…</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>

        <ng-container *ngSwitchCase="'enum'">
          <button type="button" class="sl-advanced-value" *ngIf="condition.op === 'isAnyOf'"
                  (click)="toggleConditionEditor(condition.id)">{{conditionChipValue(condition)}}</button>
          <select class="sl-advanced-select" *ngIf="condition.op !== 'isAnyOf' && conditionArgCount(condition) > 0"
                  [ngModel]="condition.value"
                  (ngModelChange)="setConditionValue(condition, $event)">
            <option [ngValue]="null">Select…</option>
            <option *ngFor="let option of enumOptions(condition)" [ngValue]="option.value">{{option.label}}</option>
          </select>
        </ng-container>

        <input type="text" class="sl-advanced-text" *ngSwitchCase="'text'"
               [ngModel]="condition.value"
               (ngModelChange)="setConditionValue(condition, $event)"
               placeholder="Type to match…" />

        <ng-container *ngSwitchCase="'date'">
          <ng-container *ngIf="conditionArgCount(condition) > 0">
            <input [type]="dateInputType(condition)" class="sl-advanced-date"
                   [ngModel]="condition.value"
                   (ngModelChange)="setConditionValue(condition, $event)" />
            <ng-container *ngIf="conditionArgCount(condition) === 2">
              <span class="sl-advanced-op">and</span>
              <input [type]="dateInputType(condition)" class="sl-advanced-date"
                     [ngModel]="condition.value2"
                     (ngModelChange)="setConditionValue2(condition, $event)" />
            </ng-container>
          </ng-container>
        </ng-container>

      </ng-container>
    </ng-container>

    <button type="button" class="sl-advanced-remove" (click)="removeCondition(condition)">&times;</button>
  </div>

  <button type="button" class="sl-filter-add" (click)="addCondition()">+ Add filter</button>

  <p class="sl-advanced-note">{{advancedNote}}</p>
</div>
